module.exports = __webpack_public_path__ + "static/img/arachas1.1efd211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/arachas1.png
// module id = NoWg
// module chunks = 0